import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_305: DocMigration = {
  maxSchemaVersion: "0.0.305",
  description: "Remove edgeId from entities that are not supposed to have it.",
  apply(json: any): any {
    for (const key in isTableBasedDocEntityTypeLookup) {
      if (isEdgeIdBasedEntityTypeLookup[key]) {
        continue;
      }

      const table = json[docEntityTypeToDocTableName[key]];
      if (table) {
        // casework is not edgeId based if it is of type "DYNAMIC"
        if (key === "CASEWORK") {
          for (const id in table) {
            const entity = table[id];
            if (entity && entity.type === "DYNAMIC") {
              delete entity.edgeId;
            }
          }
        } else {
          for (const id in table) {
            const entity = table[id];
            if (entity && entity.edgeId) {
              delete entity.edgeId;
            }
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_305;

const isTableBasedDocEntityTypeLookup = {
  ANNOTATION: true,
  CASEWORK: true,
  CEILING: true,
  COLUMN: true,
  CONTENT_REPLICATOR: true,
  CONTENT_TEMPLATE_INSTANCE: true,
  CONTENT_TEMPLATE: true,
  EDGE_BEHAVIOR: true,
  ELECTRICAL_DEVICE: true,
  ELECTRICAL_LAYOUT: true,
  ENTITY_SETTINGS: true,
  FLOOR: true,
  OPENING: true,
  OPTION_EFFECT: true,
  OPTION_RULE: true,
  PLAN_SET_TEMPLATE: true,
  PROP: true,
  RAILING: true,
  REFERENCE_GEOM: true,
  ROOM: true,
  SETTINGS_SET: true,
  SITE: true,
  UNDERLAY: true,
  VIEWPORT: true,
};

const docEntityTypeToDocTableName = {
  ROOM: "rooms",
  RAILING: "railings",
  UNDERLAY: "underlays",
  REFERENCE_GEOM: "referenceGeom",
  SETTINGS_SET: "settingsSets",
  ENTITY_SETTINGS: "entitySettings",
  OPTION_RULE: "optionRules",
  OPTION_EFFECT: "optionEffects",
  PROP: "props",
  CASEWORK: "casework",
  CEILING: "ceilings",
  EDGE_BEHAVIOR: "edgeBehaviors",
  OPENING: "openings",
  ANNOTATION: "annotation",
  SITE: "sites",
  COLUMN: "columns",
  FLOOR: "floors",
  ELECTRICAL_DEVICE: "electricalDevices",
  ELECTRICAL_LAYOUT: "electricalLayouts",
  PLAN_SET_TEMPLATE: "planSetTemplates",
  CONTENT_TEMPLATE: "contentTemplates",
  CONTENT_TEMPLATE_INSTANCE: "contentTemplateInstances",
  CONTENT_REPLICATOR: "contentReplicators",
  VIEWPORT: "viewports",
};

const isEdgeIdBasedEntityTypeLookup = {
  ANNOTATION: true,
  PROP: true,
  OPENING: true,
  EDGE_BEHAVIOR: true,
  COLUMN: true,
};
